<div  class="container-fluid">
    <mat-tab-group #tabGroup (selectedTabChange)="tabClick($event)" [selectedIndex]="selectedIndexVal">
        <mat-tab label="Documents" >
            <app-documents></app-documents>
        </mat-tab>
        <mat-tab label="Tenants" >
            <app-tenantmanagement></app-tenantmanagement>
        </mat-tab>
        <mat-tab label="Users" >
          <app-users></app-users>
        </mat-tab>
    </mat-tab-group>
</div>
        